<template>
  <div>
    <page-title style="font-size: 14px;" :override_data="{ resource_type: payload.resource_type, resource_id: payload.resource_id, company_id: payload.company_id }" :pageTitleAdditions="{ showWhatsApp: false }"></page-title>
    <div v-if="singleChoose">
      <BaseRadioGroup
        v-if="question"
        v-model="form.data.question.fields.option_ids.value"
        inputClass="my-4"
        labelClass="m-3"
        :options="questionOptions"
      />
    </div>
    <div v-else style="text-align: right;" dir="rtl">
      <question
        v-if="question"
        v-model="form.data.question.fields.option_ids.value"
        :question="question"
      ></question>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Question from '@/components/Question'
import PageTitle from '@/components/PageTitle'
import BaseRadioGroup from '@/components/BaseRadioGroup'
import QuestionsHelper from '@/custom/classes/questions_helper'

export default {
  name: 'questions-form',
  props: {
    payload: {
      type: Object
    },
    singleChoose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    questionOptions () {
      return this.question.options.map(v => ({ value: v.id.toString(), label: v.text, order: v.option_order })).sort((a, b) => parseInt(a.order) - parseInt(b.order))
    }
  },
  data () {
    let form_data = this.payload.data
    return {
      is_loading: false,
      question: undefined,
      questions_helper: new QuestionsHelper(),
      form: new this.$form({
        question: {
          fields: {
            option_ids: {
              value: '',
              has_error: false,
              validations: []
            },
            designator: {
              value: form_data.designator,
              has_error: false,
              validations: []
            },
            current_resource_id: {
              value: this.payload.resource_id,
              has_error: false,
              validations: []
            },
            current_type: {
              value: this.payload.resource_type,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'post',
            url: '/questions/' + form_data.id + '/answers/',
            headers: 'shared_headers'
          },
          is_used: true
        }
      })
    }
  },
  created () {
    this.$network_utils
      .getResourceQuestions({
        current_type: this.payload.resource_type,
        current_resource_id: this.payload.resource_id,
        designators: this.payload.data.designator
      })
      .then(response => {
        this.question = response[0]
        if (this.singleChoose) this.form.data.question.fields.option_ids.value = this.questions_helper.getAnsweredOptionIdsFromQuestion(this.question)[0].toString() || ''
      })
  },
  methods: {
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      const designator = this.form.data.question.fields.designator.value
      this.is_loading = true
      response.promise.then((response) => {
        if (this.payload.resource_type == 'Position' && !['urgency'].includes(designator)) {
          this.$network_utils.sendPositionUpdateEvent({ position_id: this.payload.resource_id, company_id: this.payload.company_id, status: this.payload.position_status })
        }
        this.remove(this.payload)
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Question,
    PageTitle,
    BaseRadioGroup
  }
}
</script>
